
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import { getObjectDataEqpGroupHttp, setEquipeHttp } from '@/apis/envmonitor'
import { parseImgUrl } from '@/utils'
import { Toast } from 'vant'

export default defineComponent({
  props: {
    projectId: {
      type: String,
      default: () => ''
    },
    spaceId: {
      type: String,
      default: () => ''
    },
    userIsControl: {
      type: Boolean,
      default: () => false
    }
  },
  setup(props) {
    let curtainData: any = []
    let timer: any = null
    let projectId: any = props.projectId
    const proxyData = reactive({
      curtainData: curtainData,
      userIsControl: props.userIsControl,
      lightIcon: 'arrow-down',
      showFlag: false,
      projectId: projectId,
      countText: '',  // 到记时文案
      count: 0,      // 到记时
      curtainOpen: false,
      curtainClose: false,
      parseImgUrl: parseImgUrl,
      timer: timer,
      // 获取窗帘列表
      getEqpGroup() {
        const params: any = {
          criteria: {
            projectId: props.projectId,
            spaceId: props.spaceId,   // 空间ID
            type: 0      // 0.窗帘
          },
          orders: [
            {
              column: 'sortNum',
              asc: true
            }
          ]
        }
        getObjectDataEqpGroupHttp(params).then(res => {
          const resData: any = res
          proxyData.curtainData = resData.count ? resData.content : []
          for (let i = 0; i < proxyData.curtainData.length; i++) {
            let item = proxyData.curtainData[i]
            item.childDownFlag = false
            item.childUpFlag = false
            item.childCount = 2
            item.childCountText = ''
          }
        })
      },
      // 点击展示所有的登录
      showAll() {
        proxyData.showFlag = !proxyData.showFlag
        if (proxyData.showFlag) {
          proxyData.lightIcon = 'arrow-up'
        } else {
          proxyData.lightIcon = 'arrow-down'
        }
      },
      checkCount() {
        if (proxyData.count > 0) {
          return true
        } else {
          return false
        }
      },
      // 窗帘总开关
      handleTotal(setType: string) {
        if (proxyData.userIsControl) {
          let flag = proxyData.checkCount()
          /**
           * flag：true 代表指令正在发送中，false:代表当前没有指令在发送
           */
          if (!flag) {  // 只要有一条指令在发送中，要求其它指令不能再发送
            proxyData.changeStatus(setType)
            let arr = JSON.parse(JSON.stringify(proxyData.curtainData))  // 窗帘数据
            let paramsArr = proxyData.setParams(arr, setType)
            // 更新窗帘的按钮可点击状态
            proxyData.setSwitchStatus(setType)
            // 发送窗帘指令
            setEquipeHttp(paramsArr).then(res => {
            })
          }
        } else {
          Toast('您没有当前空间的控制权限！')
        }
      },
      handleChild(setType: string, id: any, index: any) {
        if (proxyData.userIsControl) {
          let flag = proxyData.checkCount()
          /**
           * flag：true 代表指令正在发送中，false:代表当前没有指令在发送
           */
          if (!flag) {  // 只要有一条指令在发送中，要求其它指令不能再发送
            let childItem: any = proxyData.curtainData[index]
            const params = {
              projectId: proxyData.projectId,
              objectId: id,                // 设备ID/窗帘组ID
              equipmentCategory: 'CFSSES',  // 设备编码 窗帘：CFSSES
              infoCode: setType,  // 窗帘开设定：EquipOnSet 窗帘关设定：EquipOffSet
              value: 1                // 窗帘 1 移动/停止
            }
            let paramsArr = []
            paramsArr.push(params)
            // 更新窗帘的按钮可点击状态
            proxyData.changeStatus(setType, childItem)
            proxyData.setSwitchStatus(setType, childItem)
            // 发送窗帘指令
            setEquipeHttp(paramsArr).then(res => {
            })
          }
        } else {
          Toast('您没有当前空间的控制权限！')
        }
      },
      clearCurtain() {
        proxyData.curtainData.map((item: any) => {
          item.curtainClose = false
          item.curtainOpen = false
          proxyData.curtainClose = false
          proxyData.curtainOpen = false
        })
      },
      changeStatus(setType: any, item: any = null) {
        proxyData.clearCurtain()
        if (setType === 'EquipOffSet') {
          if (item) {
            item.curtainClose = true
          } else {
            proxyData.curtainClose = true
          }
        } else {
          if (item) {
            item.curtainOpen = true
          } else {
            proxyData.curtainOpen = true
          }
        }
      },
      // 窗帘状态数据
      setSwitchStatus(setType: any, item: any = null) {
        proxyData.count = 2  // 恢复count
        proxyData.countText = '指令下发中'
        proxyData.timer = setInterval(() => {
          if (proxyData.count === 0) {
            proxyData.countText = ''
            clearInterval(proxyData.timer)
            proxyData.clearCurtain()
          }
          if (proxyData.count === 1) {
            proxyData.countText = '再次点击停止窗帘'
          }
          if (proxyData.count > 0) {
            proxyData.count--
          } else {
            proxyData.count = 0
          }
        }, 1000)
      },
      // 设置发送给后台的窗帘数据
      setParams(arr: any, setType: any) {
        let paramsArr = []
        for (let i = 0; i < arr.length; i++) {
          let obj = {
            objectId: arr[i].id,                // 设备ID/窗帘组ID
            equipmentCategory: 'CFSSES',  // 设备编码 窗帘：CFSSES
            infoCode: setType,  // 窗帘开设定：EquipOnSet 窗帘关设定：EquipOffSet
            value: 1
          }
          paramsArr.push(obj)
        }
        return paramsArr
      }
    })
    const isShowChildLight = computed(() => {
      return proxyData.curtainData.length && proxyData.curtainData.length > 1
    })
    watch(
      props,
      (newProps: any) => {
        if (newProps.spaceId) {
          // 当前空间的控制权限
          proxyData.getEqpGroup()
          proxyData.userIsControl = newProps.userIsControl
        }
      }
    )
    onMounted(() => {
      // 获取空调信息
      proxyData.getEqpGroup()
    })
    return {
      isShowChildLight,
      ...toRefs(proxyData)
    }
  }
})
